import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import noVideoImage from 'images/videocam-24px.svg';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import LocalVideoTileControls from './LocalVideoTileControls';
const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: 'gray',
    border: '6px solid white',
    position: 'relative',
    height: (props) => (props.height ? props.height : '33vh'),
    width: '100%',
  },
  video: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0px',
    left: '0px',
    objectFit: 'cover',
    backgroundImage: `url(${noVideoImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    // backgroundSize: 'cover'
  },
  overlay: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    fontSize: '20px',
    zIndex: 1000,
  },
  border: {
    border: '6px solid #05C4FF',
  },
}));

LocalVideo.propTypes = {
  height: PropTypes.string,
};

export default function LocalVideo(props) {
  const classes = useStyles(props);
  const videoElement = useRef(null);

  const { localTileId, attendeeId, audioVideo, activeSpeakers, roster } = useSelector(
    ({ video, chime }) => ({
      localTileId: video.localTileId,
      attendeeId: chime.attendeeId,
      audioVideo: chime.audioVideo,
      activeSpeakers: chime.activeSpeakers,
      roster: chime.roster,
    })
  );
  useEffect(() => {
    audioVideo.bindVideoElement(localTileId, videoElement.current);
    return () => {
      audioVideo.unbindVideoElement(localTileId);
    };
    //eslint-disable-next-line
  }, [localTileId]);

  const rootStyle = clsx({
    [classes.root]: true,
    [classes.border]: roster[attendeeId]?.muted ? false : activeSpeakers.includes(attendeeId),
  });

  return (
    <div data-testid="local-video-root" className={rootStyle}>
      <div className={classes.overlay}>
        <LocalVideoTileControls />
      </div>
      <video data-testid="local-video" className={classes.video} ref={videoElement} />
    </div>
  );
}
